// AdminLoginTest.jsx

import React, { useState } from 'react';

function AdminLoginTest() {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  const API_BASE_URL = 'http://127.0.0.1:5000'; // Update with your backend URL

  const handleAdminLogin = async () => {
    setIsLoading(true);
    setError('');
    setResult('');
    
    try {
      const response = await fetch(`${API_BASE_URL}/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'mohit@mohitkishore.com',
          password: 'password123'
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        if (data.token) {
          localStorage.setItem('adminToken', data.token);
          setResult(`Login successful! Token: ${data.token.substring(0, 10)}...`);
        } else {
          setError('Response OK but no token received');
        }
      } else {
        setError(`Login failed: ${data.error || data.message || 'Unknown error'}`);
      }
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const testEndpoint = async (endpoint) => {
    setIsLoading(true);
    setError('');
    setResult('');
    
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setResult(`Endpoint ${endpoint} success! Data: ${JSON.stringify(data).substring(0, 100)}...`);
      } else {
        setError(`Endpoint ${endpoint} failed: ${data.error || data.message || 'Unknown error'}`);
      }
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white rounded-lg shadow-md mt-10">
      <h1 className="text-2xl font-bold mb-4">Admin Login Test</h1>
      
      <div className="space-y-4">
        <button
          onClick={handleAdminLogin}
          disabled={isLoading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {isLoading ? 'Loading...' : 'Test Admin Login'}
        </button>
        
        <div className="space-x-2">
          <button
            onClick={() => testEndpoint('/api/admin/homepage')}
            disabled={isLoading || !localStorage.getItem('adminToken')}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50"
          >
            Test Admin Homepage
          </button>
          
          <button
            onClick={() => testEndpoint('/api/homepage')}
            disabled={isLoading}
            className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
          >
            Test Public Homepage
          </button>
        </div>
        
        {error && (
          <div className="p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}
        
        {result && (
          <div className="p-3 bg-green-100 text-green-700 rounded">
            {result}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLoginTest;
